/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FamilyPhotoResource } from '../models/FamilyPhotoResource';
import type { StoreFamilyPhotoRequest } from '../models/StoreFamilyPhotoRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FamilyPhotosService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Upload family photo
     * Upload a family photo
     * @returns FamilyPhotoResource Family photo uploaded successfully
     * @throws ApiError
     */
    public uploadFamilyPhoto({
        family,
        requestBody,
    }: {
        /**
         * Family ID
         */
        family: number,
        requestBody?: StoreFamilyPhotoRequest,
    }): CancelablePromise<FamilyPhotoResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/families/{family}/photo',
            path: {
                'family': family,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Family not found`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Delete family photo
     * Delete a family photo
     * @returns any Family photo deleted successfully
     * @throws ApiError
     */
    public deleteFamilyPhoto({
        family,
    }: {
        /**
         * Family ID
         */
        family: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/families/{family}/photo',
            path: {
                'family': family,
            },
            errors: {
                400: `Bad request`,
                404: `Family not found`,
            },
        });
    }

}
